export class StartLoadingAction {
  static readonly type = '[APP] Start loading';
}

export class StartFastLoadingAction {
  static readonly type = '[APP] Start fast loading';
}

export class StopLoadingAction {
  static readonly type = '[APP] Stop loading';
}

export class StartDisableAction {
  static readonly type = '[APP] Start disable';
}

export class StopDisableAction {
  static readonly type = '[APP] Stop disable';
}

export class ResetLoadingAction {
  static readonly type = '[APP] Reset loading';
}

export class SetReferalAction {
  static readonly type = '[APP] Storing referal';
  constructor(public referal: Record<string, unknown>) {}
}

export class RemoveReferalAction {
  static readonly type = '[APP] Remove referal';
}
